export const GET_COURSES_SUCCESS = 'GET_COURSES_SUCCESS';
export const LOADING_MESSAGE = 'Loading ...';
export const OPEN_UP_COURSES_SUCCESS = 'OPEN_UP_COURSES_SUCCESS';
export const PUT_OFF_SUCCESS = 'PUT_OFF_SUCCESS';
export const PRE_OPEN_SUCCESS = 'PRE_OPEN_SUCCESS';
export const GET_REOPEN_INFO_SUCCESS = 'GET_REOPEN_INFO_SUCCESS';
export const SET_RES_REOPEN_SUBMIT_SUCCESS = 'SET_RES_REOPEN_SUBMIT_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
